export enum ChangeOrderRequestConfirmationType {
	Approve = "approve",
	TaskCompletion = "task-complete",
	SubmitToFinance = "submit-to-finance",
	ChangeRequest = "change-request",
	Delegation = "delegate",
	Rejection = "reject",
	Recall = "recall",
}

export enum ChangeOrderRequestStatusId {
	New = 1,
	Draft = 2,
	SubmittedForReview = 3,
	SubmittedForApproval = 4,
	Approved = 5,
	Recalled = 6,
	ChangeRequested = 7,
	Rejected = 8,
}

export enum ChangeOrderRequestStatus {
	New = "New",
	Draft = "Draft",
	SubmittedForReview = "Submitted for Review",
	SubmittedForApproval = "Submitted for Approval",
	Approved = "Approved",
	Recalled = "Recalled",
	ChangeRequested = "Change Requested",
	Rejected = "Rejected",
}

export enum ChangeOrderRequestStepHistoryStatus {
	Completed = "Completed",
	Ready = "Ready",
	Pending = "Pending",
	Recalled = "Recalled",
	ChangeRequested = "Change Requested",
	Rejected = "Rejected",
	Deleted = "Deleted",
	Delegated = "Delegated",
	Escalated = "Escalated",
	Cancelled = "Cancelled",
}

export enum ChangeOrderRequestStepHistoryStatusId {
	Completed = 1,
	Ready = 2,
	Pending = 3,
	Recalled = 4,
	ChangeRequested = 5,
	Rejected = 6,
	Deleted = 7,
	Delegated = 8,
	Escalated = 9,
	Cancelled = 10,
}

export enum ChangeOrderRequestActionType {
	Edit = "edit",
	Delete = "delete",
}

export enum ChangeOrderRequestLineActionType {
	Adjustment = "Adjustment",
	Transfer = "Transfer",
}

export enum ChangeOrderBeginTransferFrom {
	Source = 0,
	Recipient = 1,
}

export enum BudgetChangeTypeId {
	AdHoc = 1,
	MidTermReview = 2,
	AuditCorrections = 3,
	TreasuryCircular = 4,
	Emergency = 5,
}

export enum BudgetChangeType {
	AdHoc = "Ad Hoc",
	MidTermReview = "Mid Term Review",
	AuditCorrections = "Audit Corrections",
	TreasuryCircular = "Treasury Circular",
	Emergency = "Emergency",
}
